import EvaluationTermDto from "../../dto/EvaluationTermDto";

export default class EvaluationTermUpdateRequest {
  evaluationTerms = [];
  constructor(datas) {
    datas.forEach(data => {
      const evaluationTerm = new EvaluationTermDto(data);
      this.evaluationTerms.push(evaluationTerm);
    });
  }
}
